import { callOrganizationServiceApi } from '../../../apis/organizationService';

/**
 * One page of the reviews a given office has received, from organization-service.
 *
 * Only office profile pages come through here. Professional pages stay on the
 * monolith's `admin/users/{id}/reviews`, which returns reviews in both
 * directions; this endpoint deliberately carries only professional→office ones,
 * so pointing a professional page at it would empty the table.
 *
 * `officeRegistermodelId` is the filter param, confirmed against the endpoint —
 * the same name the response row uses. It is not optional in practice: an
 * ignored filter lists every office's reviews rather than erroring, which on an
 * office page reads as someone else's data.
 *
 * @param {Object} params
 * @param {string} params.officeId - The office whose reviews to list
 * @param {number} params.page - 1-based page index
 * @param {number} [params.limit] - Page size; matches `LIMIT_VALUE` in `UserReview.js`
 * @returns {Promise<import('../types/OfficeReview.api').IGetOfficeReviewsApiResponse>}
 */
export const getOfficeReviews = ({ officeId, page, limit = 15 }) =>
  callOrganizationServiceApi('get', 'admin/office-reviews', {
    params: { officeRegistermodelId: officeId, page, limit },
  });
